import styled from '@emotion/styled';

const Styles = styled.section({});

export default Styles;
